import './index.css';
import img from '../../../src/images/Filter.svg';
import img1 from '../../../src/images/Ai.svg';
import img2 from '../../../src/images/Profile.svg';
import img3 from '../../../src/images/heart2.svg'; // Icon for New Alerts
import img7 from '../../../src/images/plusicon.svg';
import img8 from '../../../src/images/Avatar3.svg';
import img9 from '../../../src/images/Gold Medal.svg';
import img10 from '../../../src/images/calendar2.svg';
import img11 from '../../../src/images/riskicon.svg';
import img12 from '../../../src/images/flag2.svg';
import img13 from '../../../src/images/heart2.svg';
import img14 from '../../../src/images/3dots.svg';
import img15 from '../../../src/images/home2.svg';
import img16 from '../../../src/images/Icon (5).svg';
import img17 from '../../../src/images/notification2.svg';
import img18 from '../../../src/images/Calendar.svg';
import img19 from '../../../src/images/patient-icon.svg'; // Patients Icon

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../config/config';

const Card = ({ title, icon, value, description, onClick }) => (
    <div className="alerts-container" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
        <div className="new-alerts-wrapper">
            <div className="new-alerts-card">
                <div><img src={icon} alt={`${title} Icon`} /></div>
                <div>
                    <h3>{title}</h3>
                    <h4>{description}</h4>
                </div>
            </div>
            <div>
                <h6>{value}</h6>
            </div>
        </div>
    </div>
);

function AlertsPage() {
    const navigate = useNavigate();
    const [patients, setPatients] = useState([]);
    const [filteredPatients, setFilteredPatients] = useState([]);
    const [newAlerts, setNewAlerts] = useState(0);
    const [highRiskPatients, setHighRiskPatients] = useState(0);
    const [multipleEvents, setMultipleEvents] = useState(0);
    const [highRiskPercentage, setHighRiskPercentage] = useState(0);
    const backendURL = `${config.backendServerHost}`;

    useEffect(() => {
    // Fetch data from backend
    fetch(`${backendURL}/patients/api/patients`) // Correct use of template string
        .then((res) => res.json())
        .then((data) => {
            setPatients(data);
            setFilteredPatients(data); // Default to showing all patients
            setNewAlerts(data.filter((p) => p.currentAlert.includes('Blood sugar')).length);
            const highRisk = data.filter((p) => p.riskLevel === 'High').length;
            setHighRiskPatients(highRisk);
            setMultipleEvents(data.filter((p) => {
                const events = parseInt(p.recentEvents.match(/\d+/)[0]);
                return events >= 3;
            }).length);
            // Calculate high-risk percentage
            const percentage = data.length > 0 ? ((highRisk / data.length) * 100).toFixed(1) : 0;
            setHighRiskPercentage(percentage);
        });
}, []);



    const filterPatients = (filterType) => {
        switch (filterType) {
            case 'all':
                setFilteredPatients(patients);
                break;
            case 'highRisk':
                setFilteredPatients(patients.filter((p) => p.riskLevel === 'High'));
                break;
            case 'multipleEvents':
                setFilteredPatients(patients.filter((p) => {
                    const events = parseInt(p.recentEvents.match(/\d+/)[0]);
                    return events >= 3;
                }));
                break;
            default:
                setFilteredPatients(patients);
        }
    };

  const navigateTo = (path, state = {}) => {
  navigate(path, { state });
};
    return (
        <div className="dashboard_container Alerts_wrapper">
            <div className="navbar_container">
                <div>
                    <h1>Alerts & High-Risk</h1>
                </div>
                <div className="navbar_icon">
                    <div className="navbar_icon_img">
                        <img src={img} alt="" />
                    </div>
                    <div className="navbar_icon_img">
                        <img src={img1} alt="" />
                    </div>
                    <div style={{ cursor: "pointer" }}>
                        <img src={img2} alt="" />
                    </div>
                </div>
            </div>
            <div className="navbar_bottom_line"></div>

            {/* Dynamic Cards */}
            <Card
                title="New Alerts"
                icon={img3}
                value={newAlerts}
                description="Today - Tue 17 Nov, 10:00 AM"
                onClick={() => filterPatients('all')}
            />
            <Card
                title="High-Risk Patients"
                icon={img11}
                value={highRiskPatients}
                description={`${highRiskPercentage}% of total`}
                onClick={() => filterPatients('highRisk')}
            />
            <Card
                title="Multiple Events"
                icon={img12}
                value={multipleEvents}
                description="Hypo/Hyper"
                onClick={() => filterPatients('multipleEvents')}
            />

            <div className="add_button add-button2">
                <button>
                    <img src={img7} alt="" />
                    <span>Add a patient</span>
                </button>
            </div>

            <div className="analysis-heading">
                <h1>Patient risk alerts</h1>
            </div>

            {/* Filtered Patient List */}
            {filteredPatients.map((patient, index) => (
                <div key={index} className="report_container alerts-wrapper-container" 
               onClick={() => {
                        console.log('Navigating to PatientInfo with:', {
                            patientName: patient.name,
                            patientAge: patient.age,
                            patientCondition: patient.type,
                        });


                        navigateTo('/patientinfo', {
                            state: { 
                                patientName: patient.name, 
                                patientAge: patient.age, 
                                patientCondition: patient.type 
                            },
                        });
                    }}
                    >


                    <div className="profile_wrapper">
                        <div className="profile-text">
                            <div><img src={img8} alt="" /></div>
                            <div>
                                <h2>{patient.name}</h2>
                                <h3>{patient.age}<br />{patient.type}</h3>
                            </div>
                        </div>
                        <div>
                            <img src={img9} alt="" />
                        </div>
                    </div>
                    <div className="report_card_content">
                        <div><img src={img10} alt="" /></div>
                        <div>
                            <h1>Current Alert Status:</h1>
                            <p>{patient.currentAlert}</p>
                        </div>
                    </div>
                    <div className="report_card_content">
                        <div><img src={img11} alt="" /></div>
                        <div>
                            <h1>Risk Level:</h1>
                            <p>{patient.riskLevel}</p>
                        </div>
                    </div>
                    <div className="report_card_content">
                        <div><img src={img12} alt="" /></div>
                        <div>
                            <h1>Recent Hypo/Hyper Events:</h1>
                            <p>{patient.recentEvents}</p>
                        </div>
                    </div>
                    <div className="report_card_content">
                        <div><img src={img13} alt="" /></div>
                        <div>
                            <h1>Next Follow-Up:</h1>
                            <p>{patient.followUps}</p>
                        </div>
                    </div>
                    <div className="analysis_button_container">
                        <div className="analysis_button">
                            <button>Call</button>
                            <button>SMS</button>
                        </div>
                        <div>
                            <img src={img14} alt="" />
                        </div>
                    </div>
                </div>
            ))}

            <div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/dashboard-page')}>
                        <img src={img15} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img16} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img17} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img18} alt="Calendar Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/Aianalysis1')}>
                        <img src={img19} alt="Patient Icon" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AlertsPage;
